<template>
  <div class="pg-pc">
    <div class="qrcode"></div>
    <!-- <div class="text">请使用手机微信扫码访问</div> -->
  </div>
</template>
<script>
import store from '~/store/index';
import * as types from '~/store/mutation-type';

export default {
  mounted() {
    store.commit(types.SHOW_LOADING, false);
  }
}
</script>

<style lang="stylus" scoped>
  .pg-pc
    width 100%
    height 100vh
    display flex
    justify-content center
    align-items center
    background-color rgba(0,0,0,0.75)
    .qrcode
      background-image url('./images/qrcode.png')
      width 243px
      height 255px
      background-size contain
    .text
      width 100%
      font-size 22px
      text-align center
</style>
